<button (click)="back()" class="button">
  <span class="pi pi-arrow-left"></span>
  <span>Voltar</span>
</button>
